import type { FaireProductEntity } from "../../entity_types/product";

export const p_49mh9kfi: FaireProductEntity = {
  token: "p_49mh9kfi",
  type: "product",
  name: "Multi Stripes Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d528160fc32f3fa40ae2afc0cb923ec4206bda36a2455a021a6108d377fa272d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/d7fd9d8cb44e4840d7ae17cbf3c80b7028e683f77e12fb4dea5d67d717b9709e/1558642483.png",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/7cf871f929173fa0fc70a65a891f924aaee92aae46e59c6f6ef4361f6b6d6827/1558642468.png",
    "https://cdn.faire.com/fastly/6c8c4b72fa7bba3d997b411b3c0a4d9061213b0e3c2a3cb8979c8e2829036f1f.png",
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
  ],
  priceDollars: 9,
  description:
    "Who doesn't love a fresh, crisp and clean new notepad?! It's such a hopeful item. Just think of all you will go through together! \n\nAt E. Frances, we want each page to bring joy to your list-making, doodling and note-taking.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:50.649Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
